import {
  normalBoy,
  normalGirl,
  obeseBoy,
  obeseGirl,
  overWeightGirl,
  underWeightBoy,
  overWeightBoy,
  underWeightGirl,
} from "../../../Assets/images";
import GlobalStyle from "../../../styles/GlobalStyle";
import { scaleVertical, scaleHorizontal } from "../../../styles/responsive";
import { V2ReportStyle } from "../../../styles/V2ReportStyle";
import { getStatusStyles } from "../../../utils/helpers/dentalHelper";
import { BMIIconSvg } from "../../../utils/Svgs";
import StatusLabel from "../../UI/StatusLabel";

const BMICard = ({
  lable = "Normal",
  type,
  data,
  gender,
}: {
  lable: any;
  type: any;
  data: any;
  gender: "M" | "F";
}) => {
  const { backgroundColor, color } = getStatusStyles(lable);

  function getImg(rangeType: string, studentGender: "M" | "F") {
    const standardizedType = (rangeType || "").toLowerCase().trim();

    const imageSet =
      studentGender === "M"
        ? {
            normal: normalBoy,
            overweight: overWeightBoy,
            obese: obeseBoy,
            underweight: underWeightBoy,
          }
        : {
            normal: normalGirl,
            overweight: overWeightGirl,
            obese: obeseGirl,
            underweight: underWeightGirl,
          };
    if (standardizedType === "over weight") return imageSet.overweight;
    if (standardizedType === "under weight") return imageSet.underweight;

    if (standardizedType === "obese") return imageSet.obese;
    if (standardizedType === "overweight") return imageSet.overweight;
    if (standardizedType === "underweight") return imageSet.underweight;

    // Label says Need Attention but range text is missing/unknown → never use green normal image

    return imageSet.normal;
  }
  return (
    <div style={{ ...V2ReportStyle.card, gap: scaleVertical(12) }}>
      <div
        style={{
          ...V2ReportStyle.flexRowCenter,
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ ...V2ReportStyle.flexRowCenter, gap: scaleHorizontal(2) }}
        >
          <BMIIconSvg />
          <span style={{ ...GlobalStyle.blackBoldText, fontSize: "2.2rem" }}>
            BMI
          </span>
        </div>
        <StatusLabel lable={lable} />
      </div>

      <div style={{ ...V2ReportStyle.flexRowCenter, gap: scaleHorizontal(12) }}>
        <div style={{ ...V2ReportStyle.bmiUserContainer, backgroundColor }}>
          <img
            style={V2ReportStyle.bmiUser}
            src={getImg(type, gender)}
            alt="BMI Status"
          />
        </div>

        <div
          style={{ ...V2ReportStyle.flexColumnCenter, gap: scaleVertical(10) }}
        >
          <div
            style={{
              ...V2ReportStyle.measurebox,
              borderColor: color,
              backgroundColor,
            }}
          >
            <span
              style={{
                ...GlobalStyle.blackBoldText,
                fontSize: "2rem",
                color,
              }}
            >
              {data?.bmi?.toFixed(1)}
            </span>
          </div>
          <p
            style={{
              ...GlobalStyle.blackRegularText,
              fontSize: "2rem",
              margin: 0,
            }}
          >
            National BMI range for a{" "}
            <span style={GlobalStyle.blackBoldText}>{data?.age_text}</span>{" "}
            <span style={GlobalStyle.blackBoldText}>
              {data?.gender == "M" ? "boy" : "girl"}
            </span>{" "}
            is{" "}
            <span style={GlobalStyle.blackBoldText}>
              {data?.bmi_normal_lower} to {data?.bmi_normal_upper}
            </span>{" "}
            . Your child is categorized as{" "}
            <span style={GlobalStyle.blackBoldText}>{data?.bmi_range}</span> for
            {data?.gender == "M" ? " his" : " her"} age.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BMICard;
